import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../actionTypes';

/**
 * @typedef {string} ScrollIntoViewState
 */

/** @type {ScrollIntoViewState} */
const initialState = null;

/**
 * @param {ScrollIntoViewState} _
 * @param {import('../types').ScrollIntoViewAction} action
 * @returns {import('../types').ScrollIntoViewAction}
 */
const set = (_, { payload: selector }) => selector;

export default createReducer(initialState, {
  [actionTypes.SCROLL_INTO_VIEW]: set,
});
